import React, { CSSProperties, useEffect, useState } from "react"
import { useAppDispatch } from "../../app/store"
import { useNavigate, useSearchParams } from "react-router-dom"
import { toast } from "react-toastify"
import CenteredSpinner from "../common/CenteredSpinner"
import { useEmailVerifyQuery } from "../../features/EmailVerifyAuth/emailVerifyAuth"
import { emailVerifyToken } from "../../features/EmailVerifyAuth/emailVerifySlice"
import { useAppSelector } from "../../app/hooks"


function formatTimeOut(timeLeft: number | null) {
  if (timeLeft === null) return ''
  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
}

export default function EmailVerify() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [urlSearchParams] = useSearchParams()
  const token = urlSearchParams.get("token")
  const [timeLeft, setTimeLeft] = useState<number | null>(null)
  const { error, data, isLoading } = useEmailVerifyQuery(
        { token },
    {
      skip: !token,
      refetchOnMountOrArgChange: true
    }
  )

  useEffect(() => {
    if (data) {
      toast.success(data.message || "Verification successful!", { autoClose: 1000 })
       setTimeLeft(10) // 10 seconds
    } else if (error) {
      if((error as any)?.status === 409) setTimeLeft(10) // 10 seconds
      toast.error((error as any)?.data?.message || "Verification failed.")
    }
  }, [data, error, dispatch])

    useEffect(() => {
    if (timeLeft === null) return

    if (timeLeft <= 0) {
      navigate("/")
      return
    }

    const interval = setInterval(() => {
      setTimeLeft((prev) => (prev !== null ? prev - 1 : null))
    }, 1000)

    return () => clearInterval(interval)
  }, [timeLeft, navigate])

  return (
        <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div
            className="card shadow text-center p-4"
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '25px',
              border: '1px solid #f1f1f1',
            }}
          >
            <h3 className="mb-3" style={{ color: '#F475A4' }}>
              Email Verification
            </h3>

            {isLoading && (
              <>
                <CenteredSpinner />
                <p className="mt-3" style={{ color: '#666' }}>
                  Verifying Token, Please Wait...
                </p>
              </>
            )}

            {!isLoading && data && (
              <>
                <div
                  className="alert alert-success"
                  style={{
                    backgroundColor: '#F475A4',
                    border: 'none',
                    color: 'white',
                    borderRadius: '15px',
                  }}
                  role="alert"
                >
                  {data.message || 'Successfully verified!'}
                </div>
                <p style={{ color: '#555' }}>
                  You Will Be Redirected In{' '}
                  <strong style={{ color: '#F475A4' }}>{formatTimeOut(timeLeft)}</strong>
                </p>
                <button
                  className="btn mt-3"
                  onClick={() => navigate('/')}
                  style={{
                    backgroundColor: '#F475A4',
                    color: '#fff',
                    borderRadius: '25px',
                    padding: '10px 20px',
                    border: 'none',
                  }}
                >
                  Go To Login Now
                </button>
              </>
            )}

            {!isLoading && error && (
              <div className=" d-flex flex-column gap=3">
                {
                  timeLeft&&<div className=" d-flex flex-column gap-3 justify-content-around">
                  <p style={{ color: '#555' }}>
                  You Will Be Redirected In{' '}
                  <strong style={{ color: '#F475A4' }}>{formatTimeOut(timeLeft)}</strong>
                </p>
                <button
                  className="btn my-3"
                  onClick={() => navigate('/')}
                  style={{
                    backgroundColor: '#F475A4',
                    color: '#fff',
                    borderRadius: '25px',
                    padding: '10px 20px',
                    border: 'none',
                  }}
                >
                  Go To Login Now
                </button>
                  </div>
                }
              
              <div
                className="alert alert-danger"
                role="alert"
                style={{
                  borderRadius: '15px',
                }}
              >
                {(error as any)?.data?.message || 'Verification failed!'}
              </div>
              </div>
            )}

            {!token && !isLoading && (
              <p className="text-muted">
                No Token Provided. Please Check Your Verification Link.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}


